import { Channel, I18N, I18N_DEFAULT } from '@monofront/business/constants';
import { NextRouter, useRouter } from 'next/router';
import { CountryCode } from 'libphonenumber-js/min';

interface II18nHook {
  locale: string;
  channel: Channel;
  countryCode: CountryCode;
  iso: string;
  currency: string;
  isFrenchMarket: boolean;
  isGermanMarket: boolean;
  domain: string;
  availableCountryLocale: string;
  availableCountryCodes: CountryCode[];
}

const useI18n = (): II18nHook => {
  // @todo: upgrade to Algolia v7
  // We add a fallwback to useRouter (which should always be defined)
  // because of an edge-case linked to the 1st rendering SSR of Algolia.
  // When a component is 1st rendered via findResultsState(),
  // the Router does not exist
  // https://github.com/algolia/react-instantsearch/issues/3596
  let router = {} as NextRouter;

  try {
    router = useRouter();
  } catch {
    // Fails silently
  }
  const { locale = I18N_DEFAULT.locale } = router;

  const isFrenchMarket = locale === I18N.fr.locale;
  const isGermanMarket = locale === I18N.de.locale;

  return {
    ...I18N[locale],
    isFrenchMarket,
    isGermanMarket,
  };
};

export default useI18n;
